import { get, post, put } from '../api-config';

const griService = '/gri';

export interface GriResidence {
  id: string;
  residenceId: string;
  groupId: string;
  name: string;
  serverId: string;
  active: boolean;
}

export interface SyncRecord {
  id: string;
  residenceId: string;
  residenceName: string;
  triggeredBy: 'SCHEDULED' | 'MANUAL';
  startedAt: string;
  finishedAt: string;
  status: 'SUCCESS' | 'ERROR';
  residentsFetched: number;
  residentsCreated: number;
  residentsUpdated: number;
  residentsSkipped: number;
  residentsDeleted: number;
  usersFetched: number;
  usersCreated: number;
  usersUpdated: number;
  usersSkipped: number;
  usersDeleted: number;
  errorMessage: string | null;
}

interface GriEnvelope<T> {
  status: 'success' | 'error';
  message: string;
  data: T;
}

export interface GriServer {
  id: string;
  name: string;
  endpointUrl: string;
  user: string;
  password: string;
  customerReference: string;
  extension: number;
  parentGroupId: string;
}

export const getResidencesByGroup = (groupId: string) =>
  get(griService, `/residences/group/${groupId}`) as Promise<{ data: GriEnvelope<GriResidence[]> }>;

export const putResidence = (residence: GriResidence) =>
  put(griService, '/residences', residence) as Promise<{ data: GriEnvelope<GriResidence> }>;

export const postResidenceSync = (residenceId: string) =>
  post(griService, `/residences/${residenceId}/sync`) as Promise<{ data: GriEnvelope<unknown> }>;

export const getSyncHistory = (residenceId: string, page = 0, size = 20) =>
  get(griService, '/sync/history', {}, { residenceId, page, size }) as Promise<{ data: GriEnvelope<SyncRecord[]> }>;

export const putServer = (server: GriServer) =>
  put(griService, '/servers', server) as Promise<{ data: GriEnvelope<GriServer> }>;

export const getServersByGroup = (groupId: string) =>
  get(griService, `/servers/group/${groupId}`) as Promise<{ data: GriEnvelope<GriServer[]> }>;

export const getSyncHistoryDetail = (id: string) =>
  get(griService, `/sync/history/${id}`) as Promise<{ data: GriEnvelope<SyncRecord> }>;
